/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".copyUrlLink[_ngcontent-%COMP%]{color:#005cab;position:absolute;right:5px;top:35%;cursor:pointer}.dnlLink[_ngcontent-%COMP%]{padding-right:10px;display:block}.saveNotification[_ngcontent-%COMP%]{position:absolute;right:25px;top:5px;border:1px solid #ccc;padding:5px 10px;border-radius:5px;box-shadow:0 1px 3px #aaa;background-color:#fff}.saveNotification[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{color:#093;margin-right:4px}"];
export { styles as styles };
